// extracted by mini-css-extract-plugin
module.exports = {"protectionData":"style_protectionData__P0Rvc"};